import { render, staticRenderFns } from "./newpayok.vue?vue&type=template&id=6b80fc9e&scoped=true&"
import script from "./newpayok.vue?vue&type=script&lang=js&"
export * from "./newpayok.vue?vue&type=script&lang=js&"
import style0 from "./newpayok.vue?vue&type=style&index=0&id=6b80fc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80fc9e",
  null
  
)

export default component.exports